webpackJsonp([454],{

/***/ 1712:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(897),
  /* template */
  __webpack_require__(2455),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/cookie-304.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] cookie-304.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-de59d8d4", Component.options)
  } else {
    hotAPI.reload("data-v-de59d8d4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2455:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("cookie")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { cookie } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("get *cookie.get(name, [options])*")])]), _vm._v(" "), _c('p', [_vm._v("获取 cookie 值。"), _c('code', [_vm._v("options")]), _vm._v(" 参数可选，取值如下：")]), _vm._v(" "), _c('ol', [_c('li', [_c('code', [_vm._v("converter")]), _vm._v(" 转换函数。如果所获取的 cookie 有值，会在返回前传给 "), _c('code', [_vm._v("converter")]), _c('br'), _vm._v("\n函数进行转换。")]), _vm._v(" "), _c('li', [_vm._v("选项对象。对象中可以有两个属性："), _c('code', [_vm._v("converter")]), _vm._v(" 和 "), _c('code', [_vm._v("raw")]), _vm._v(". "), _c('code', [_vm._v("raw")]), _vm._v(" 是布尔值，为真时，不会对获取到的"), _c('br'), _vm._v("\ncookie 值进行 URI 解码。")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("注")]), _vm._v("：如果要获取的 cookie 键值不存在，则返回 "), _c('code', [_vm._v("undefined")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("例子：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// setup")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("document")]), _vm._v(".cookie = "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'foo=1'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("document")]), _vm._v(".cookie = "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'bar=2'")]), _vm._v("\n\ncookie.get("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'foo'")]), _vm._v(")\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// returns '1'")]), _vm._v("\n\ncookie.get("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'bar'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v("("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("s")]), _vm._v(") ")]), _vm._v("{ "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("parseInt")]), _vm._v("(s); } )\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// returns 2")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("set *cookie.set(name, value, [options])")])]), _vm._v(" "), _c('p', [_vm._v("设置 cookie 值。参数 "), _c('code', [_vm._v("options")]), _vm._v(" 可选，可以有以下属性："), _c('code', [_vm._v("path")]), _vm._v("（字符串）、"), _c('code', [_vm._v("domain")]), _vm._v("（字符串）、"), _c('br'), _vm._v(" "), _c('code', [_vm._v("expires")]), _vm._v("（数值或日期对象）、"), _c('code', [_vm._v("raw")]), _vm._v("（布尔值）。当 "), _c('code', [_vm._v("raw")]), _vm._v(" 为真值时，在设置 cookie 值时，不会进行"), _c('br'), _vm._v("\nURI 编码。")]), _vm._v(" "), _c('p', [_vm._v("例子：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("cookie.set("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'foo'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("3")]), _vm._v(")\n\ncookie.set("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'bar'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("4")]), _vm._v(", {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("domain")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'example.com'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("path")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'/'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("expires")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("30")]), _vm._v("\n})\n")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("remove *cookie.remove(name, [options])")])]), _vm._v(" "), _c('p', [_vm._v("移除指定的 cookie.")]), _vm._v(" "), _c('p', [_vm._v("例子：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("cookie.remove("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'foo'")]), _vm._v(")\n\ncookie.remove("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'bar'")]), _vm._v(", {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("domain")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'example.com'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("path")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'/'")]), _vm._v("\n})\n")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-de59d8d4", module.exports)
  }
}

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1712);

/***/ }),

/***/ 897:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "cookie | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 454.c9126413.js